import { configureRequest } from '../../../../networkRequests/apiClient/apiClient.functions'
import urls from '../../../../networkRequests/apiClient/endpoints'
import { UserRole } from '../../../../shared/functions/UserRole/userRoleManagement.types'
import {
  CreateAccountSessionErrorResponse,
  CreateAccountSessionRequest,
  CreateAccountSessionSuccessResponse
} from './createAccountSession.types'

export const createAccountSessionApi = async (
  request: CreateAccountSessionRequest
): Promise<CreateAccountSessionSuccessResponse> => {
  const response = await configureRequest({
    url: urls.payments.createAccountSession,
    method: 'POST',
    data: request,
    params: {},
    headers: {
      'X-User-Role': UserRole.traveler
    }
  })

  if (response.status >= 200 && response.status < 300) {
    return response as CreateAccountSessionSuccessResponse
  } else {
    throw response as CreateAccountSessionErrorResponse
  }
}

export default createAccountSessionApi
